// Platform helpers. This panel is operated mostly from Windows, so keyboard
// hints default to the Windows/Linux modifier ("Strg") and only show the mac
// glyph (⌘) on actual macOS.
export const isMac =
  typeof navigator !== "undefined" &&
  /mac|iphone|ipad|ipod/i.test(navigator.platform || navigator.userAgent || "");

/** Label for the primary command modifier, e.g. "Strg" on Windows, "⌘" on macOS. */
export const modKey = isMac ? "⌘" : "Strg";

/** Full shortcut label, e.g. "Strg K" / "⌘K". */
export const shortcut = (key: string) => (isMac ? `${modKey}${key}` : `${modKey} ${key}`);
